import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './style.css'
import './styles/reduce-motion.css'
import { analytics } from './services/analytics'

const app = createApp(App)
app.use(createPinia())
app.use(router)

// Initialize Google Analytics
analytics.init().catch(console.error)

app.mount('#app')
